export default __webpack_public_path__ + "media/images/temporary/mud-run-2-38d2950f3564253868e4dc41cb2f2fd8.jpg";